export default __webpack_public_path__ + "static/media/36I-102764_-15873_0.f0cfcf4a.jpg";